var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Orders"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.2296 19.7912L21.158 6.28608C21.0915 5.41594 20.3553 4.73461 19.4828 4.73461H17.3657V7.87134C17.3657 8.2598 17.0513 8.57423 16.6628 8.57423C16.2749 8.57423 15.96 8.2598 15.96 7.87134V4.73461H9.4935V7.87134C9.4935 8.2598 9.1786 8.57423 8.79061 8.57423C8.40216 8.57423 8.08772 8.2598 8.08772 7.87134V4.73461H5.97066C5.09817 4.73461 4.362 5.41594 4.29549 6.2842L3.22336 19.7931C3.14044 20.875 3.51577 21.9518 4.25283 22.7475C4.98994 23.5431 6.03488 24 7.11966 24H18.3338C19.4186 24 20.4636 23.5431 21.2007 22.7475C21.9377 21.9518 22.3131 20.875 22.2296 19.7912ZM15.8934 12.9137L12.2581 16.549C12.1929 16.6144 12.1155 16.6663 12.0301 16.7017C11.9448 16.7371 11.8533 16.7553 11.761 16.7552C11.6686 16.7553 11.5772 16.7371 11.4918 16.7017C11.4065 16.6663 11.329 16.6144 11.2638 16.549L9.56007 14.8453C9.28547 14.5707 9.28547 14.126 9.56007 13.8514C9.83466 13.5768 10.2798 13.5768 10.554 13.8514L11.761 15.058L14.8996 11.9194C15.1737 11.6453 15.6189 11.6453 15.8935 11.9194C16.168 12.194 16.168 12.6391 15.8934 12.9137ZM12.7268 0C10.1687 0 8.08777 2.08144 8.08777 4.63945L8.08772 4.73461H9.4935L9.49355 4.63945C9.49355 2.85647 10.9438 1.40573 12.7268 1.40573C14.5098 1.40573 15.96 2.85647 15.96 4.63945L15.96 4.73461H17.3657L17.3658 4.63945C17.3657 2.08144 15.2848 0 12.7268 0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderWhite);
export default __webpack_public_path__ + "static/media/order_white.11057aa0a610b2369a7490594f9d6e57.svg";
export { ForwardRef as ReactComponent };